var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.userConf.view.theme,"short-title":_vm.$t('sidebar.shortTitle'),"title":_vm.$t('sidebar.title')},scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-wallet-43',
          path: '/dashboard'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.instruments'),
          icon: 'tim-icons icon-zoom-split',
          path: '/instruments'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.screeners'),
          icon: 'tim-icons icon-light-3',
          path: '/screeners'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.trackrecord'),
          icon: 'tim-icons icon-watch-time',
          path: '/track-record'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.notes'),
          icon: 'tim-icons icon-notes',
          path: '/notes'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Profil',
          icon: 'tim-icons icon-single-02',
          path: '/pages/user'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.pro'),
          icon: 'tim-icons icon-spaceship',
          path: '/pro'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.faq'),
          icon: 'tim-icons icon-bulb-63',
          path: '/faq'
        }}}),(_vm.userConf.pepitorAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.pepitoradmin'),
          icon: 'tim-icons icon-controller',
          path: '/pepitor-admin'
        }}}):_vm._e(),(_vm.userConf.admin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.admin'),
          icon: 'tim-icons icon-key-25',
          path: '/admin'
        }}}):_vm._e()]}}])}),_c('sidebar-share',{attrs:{"background-color":_vm.sidebarBackground},on:{"update:backgroundColor":function($event){_vm.sidebarBackground=$event},"update:background-color":function($event){_vm.sidebarBackground=$event}}}),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }